import { ChangeEvent, useCallback, useState } from 'react';
import { Formatter, ValueExtractor } from './types';

export const useMaskedInput = (
    formatter: Formatter,
    initialValue: string = '',
    onChange: (event: ChangeEvent<HTMLInputElement>) => void,
    valueExtractor: ValueExtractor = (value) => value.replace(/\D/g, ''),
) => {
    const [value, setValue] = useState(formatter(initialValue));

    const handleChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const rawValue = e.target.value;
            const formattedValue = formatter(rawValue);
            setValue(formattedValue);

            const event = {
                ...e,
                target: {
                    ...e.target,
                    value: valueExtractor(formattedValue),
                },
            };
            onChange(event);
        },
        [formatter, onChange, valueExtractor],
    );

    return {
        value,
        onChange: handleChange,
    };
};
